import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckoutForm from "./StripeForm";
import styled from "styled-components";
import { loadStripe } from "@stripe/stripe-js";

const Layout = styled.div`
    position: fixed;
    padding: 0 10px;
    width: 630px;

    @media only screen and (max-width: 550px) {
      width: 100vw !important;
      max-width: 100vw !important;
      min-width: 100vw !important;
      left: 0 !important;
      right: 0 !important;
      
      &.open {
        transform: translateX(0) !important;
      }
    }
    
    top: 60px;
    right: -20px;
    background: #161616;
    box-shadow: 0 15px 60px rgba(0, 0, 0, 0.15);
    z-index: 9999 !important;
    transform: translateX(100%);
    transition: all 150ms ease-in-out;
    overflow: auto;
    display: grid;
    grid-template-rows: 1fr auto;
    grid-gap: 25px;
    bottom: 0; 
    border-radius: 30px;
    border: 1px solid var(--hn-green);
    &:hover{
      border-color: var(--hn-green);
    }
    &.open {
      transform: translateX(calc(0% - 20px));
    }

    .price-details-container{
      padding: 0 64px;
      color: #ffffff;

      .price-detail{
        text-align: end;
        margin: 10px;

        &.pricing-line{
          border-bottom: 1px solid;
          padding-bottom: 10px;
        }
      }
    }

    .purchase-content {
      display: flex;
      flex-direction: column;
      position: relative;

      .purchase-header{
        margin: 0;
        display: flex;
        background: #D1FF03;
        justify-content: space-between;
        padding: 12px 24px;
        margin: 0px -10px;
        color: #18191a;
        font-size: 0.8rem;
        .close-btn { 
          display: none;
          @media (max-width: 700px) {
            display: block;
            position: absolute;
            right: 15px;
            border: 1px solid #8c7c00;
            padding: 5px 10px;
            border-radius: 50%;
            top: 0;
            font-weight: 700;
          }
        }

        .hn-logo{
          width: 200px;
          img{
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      button.close, button.open, button.expand, button.hn-lock  {
        border: none;
        background: transparent;
        font-size: 18px;
        color: #ccc;
        padding: 0;
        margin: 0 5px;
        cursor: pointer;
        align-self: flex-start;
      }

      p {
        color: #424242;
      }
    }

    .main-image {
      width: 100%;
      height: 175px;
      object-fit: cover;
    }
  }	

`;

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
// const stripePromise = loadStripe("pk_test_7RVrJVYbQvpyakyqcE1Onsw4");


const formatUSD = amount => {
  // Convert cents to dollars if amount is an integer >= 100 and not already decimal
  const value = typeof amount === "number" ? amount : parseFloat(amount);

  const options = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  };

  return new Intl.NumberFormat("en-US", options).format(value);
};

export function StripeProviderForPaymentMethod({ children }) {
  return <Elements stripe={stripePromise}>{children}</Elements>;
}

export default function Purchase({ showPurchase = false, close, checkoutData = null, onStory = false, customerCards = [], applyCoupon }) {
  const handleClose = () => {
    window.gtag?.("event", "stripe_checkout_closed", {
      event_category: "ecommerce",
      event_label: "user_dismissed_checkout",
    });

    close(); // call the original close function
  };

  return (
    <Layout
      className={`${showPurchase ? "open purchase-screen" : "purchase-screen"}`}
    // onScroll={handleScroll}
    >
      <div className="purchase-content">
        <div className="purchase-header">
          <div className="hn-logo">
            <img src="/images/hackernoon-logo-black.png" alt="Hackernoon logo" />
          </div>
          <div>
            <h2>Checkout ({checkoutData?.count}) item</h2>
          </div>
          <span onClick={handleClose} className="close-btn">x</span>
        </div>
        <br />
        <div className="price-details-container">
          <h4 className="price-detail"> SubTotal: {formatUSD(checkoutData?.subTotal)} </h4>
          {checkoutData?.discount && (
            <h4 style={{color: "#ff7f7f"}} className="price-detail discount">Discount: -{checkoutData?.discount?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </h4>
          )}
          <h4 className="price-detail pricing-line">Tax: {formatUSD(checkoutData?.tax)}</h4>
          <h3 
            className="price-detail"
            style={checkoutData?.discount ? {color: "#00ff00"} : {}}
            >
            Total: {formatUSD(checkoutData?.totalPrice)} </h3>

          {/* <CheckoutService checkoutData={checkoutData} type="checkout" /> */}
        </div>

        {checkoutData?.intent && (
          <Elements
            options={{
              clientSecret: checkoutData?.intent?.secret,
              appearance: {
                variables: {
                  colorPrimary: '#D1FF03',
                  colorBackground: '#161616',
                  colorText: '#ffffff',
                  borderRadius: '8px',
                  focusBoxShadow: 'none',
                }
              },
            }}
            stripe={stripePromise}
          >
            <StripeCheckoutForm
              customerCards={customerCards}
              params={{ ...checkoutData?.params }}
              applyCoupon={applyCoupon}
              paymentIntentId={checkoutData?.intent?.id}
            />
          </Elements>
        )}
      </div>
    </Layout>
  );
}
